var popoverDefaultValues = {
  showContainerPointer: true
};

export { popoverDefaultValues };
